import { useQueryClient as c, useMutation as s } from "@tanstack/vue-query";
import { campaignKeys as o } from "../campaign/queries.js";
import { adGroupKeys as r } from "./queries.js";
import "../creative-group/queries.js";
import "vue";
const G = (u, i) => {
  const n = c(), e = i?.onSuccess;
  return s({
    ...i,
    mutationFn: async (a) => u.adGroup.create(a),
    onSuccess: async (...a) => {
      const [, t] = a;
      await n.invalidateQueries({ queryKey: r.byCampaign(t.campaignId) }), await n.invalidateQueries({ queryKey: o.all }), e && e(...a);
    }
  });
}, Q = (u, i) => {
  const n = c(), e = i?.onSuccess;
  return s({
    ...i,
    mutationFn: async (a) => u.adGroup.copy(a),
    onSuccess: async (...a) => {
      const [, t] = a;
      await n.invalidateQueries({ queryKey: r.byCampaign(t.campaignId) }), await n.invalidateQueries({ queryKey: o.all }), e && e(...a);
    }
  });
}, v = (u, i) => {
  const n = c(), e = i?.onSuccess;
  return s({
    ...i,
    mutationFn: async (a) => {
      const { campaignId: t, ...d } = a;
      await u.adGroup.update(d);
    },
    onSuccess: async (...a) => {
      const [, t] = a;
      await n.invalidateQueries({ queryKey: r.byCampaign(t.campaignId) }), await n.invalidateQueries({ queryKey: o.all }), e && e(...a);
    }
  });
}, w = (u, i) => {
  const n = c(), e = i?.onSuccess;
  return s({
    ...i,
    mutationFn: async (a) => {
      const { campaignId: t, ...d } = a;
      await u.adGroup.rename(d);
    },
    onSuccess: async (...a) => {
      const [, t] = a;
      await n.invalidateQueries({ queryKey: r.byCampaign(t.campaignId) }), await n.invalidateQueries({ queryKey: o.all }), e && e(...a);
    }
  });
}, K = (u, i) => {
  const n = c(), e = i?.onSuccess;
  return s({
    ...i,
    mutationFn: async (a) => u.adGroup.remove({ params: { adGroupId: a.adGroupId }, query: { force: a.force ?? !1 } }),
    onSuccess: async (...a) => {
      const [, t] = a;
      n.removeQueries({
        queryKey: r.detail(t.campaignId, t.adGroupId)
      }), await n.invalidateQueries({ queryKey: r.byCampaign(t.campaignId) }), await n.invalidateQueries({ queryKey: o.all }), e && e(...a);
    }
  });
}, S = (u, i) => {
  const n = c();
  return s({
    ...i,
    mutationFn: async (e) => {
      const { campaignId: a, ...t } = e;
      await u.adGroup.update(t);
    },
    onMutate: async (e) => {
      await n.cancelQueries({
        queryKey: r.detail(e.campaignId, e.adGroupId)
      });
      const a = n.getQueryData(
        r.detail(e.campaignId, e.adGroupId)
      );
      if (a) {
        const { adGroupId: t, campaignId: d, ...y } = e, p = {
          ...a,
          ...y
        };
        n.setQueryData(r.detail(e.campaignId, e.adGroupId), p);
      }
      return a !== void 0 ? { previousData: a } : {};
    },
    onError: (e, a, t) => {
      t?.previousData && n.setQueryData(r.detail(a.campaignId, a.adGroupId), t.previousData);
    },
    onSettled: async (e, a, t) => {
      await n.invalidateQueries({ queryKey: r.byCampaign(t.campaignId) }), await n.invalidateQueries({ queryKey: o.all });
    }
  });
};
export {
  Q as useCopyAdGroup,
  G as useCreateAdGroup,
  K as useDeleteAdGroup,
  w as useRenameAdGroup,
  v as useUpdateAdGroup,
  S as useUpdateAdGroupOptimistic
};
//# sourceMappingURL=mutations.js.map
